export const paymentOptions = [
    {label: 'Наличными', value: 1},
    {label: 'Банковским переводом', value: 2},
    {label: 'Kaspi', value: 3}
];
